import React from "react";
import { RouterLink } from "mobx-state-router";

function MrbRouterLink({ children, ...props }) {
    return <RouterLink {...props}>{children}</RouterLink>;
}

export default MrbRouterLink;
